import { useState, useCallback } from 'react';

function useToggle(initialState: boolean): [boolean, () => void, () => void] {
  const [isOn, setToggle] = useState(initialState);

  const toggleOn = useCallback(() => {
    setToggle(true);
  }, [setToggle]);

  const toggleOff = useCallback(() => {
    setToggle(false);
  }, [setToggle]);

  return [isOn, toggleOn, toggleOff];
}

export default useToggle;
